module.exports = __webpack_public_path__ + "static/media/galeryCoatings2.98ad15b4.jpg";